module.exports = require('./lib/ReactWithAddons');



/** WEBPACK FOOTER **
 ** ./~/react/addons.js
 **/